export default {
  header: {
    projectName: '프로젝트 이름',
    export: '내보내기',
    debug: '디버그',
    success: '성공',
    failed: '실패',
    generating: '동영상 생성 중...',
    updateNameFailed: '프로젝트 이름 업데이트 실패',
    menu: '메뉴',
    settings: '설정',
    shortcuts: '키보드 단축키',
    about: '정보',
    darkMode: '다크 모드',
    lightMode: '라이트 모드',
    settingsComingSoon: '설정 기능 곧 출시 예정',
    shortcutsComingSoon: '단축키 기능 곧 출시 예정',
    aboutComingSoon: '정보 곧 출시 예정',
    language: '언어',
    dimensions: '크기',
    canvas: '캔버스',
    view: '보기',
    general: '일반'
  },
  menu: {
    media: '미디어',
    text: '텍스트'
  },
  loading: {
    core: '코어 로딩 중...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: '퍼블릭 베타',
    betaDisclaimer: '베타 버전, 데이터 보존이 보장되지 않음',
    newProject: '새 프로젝트',
    backupFolder: '백업 폴더',
    documentation: '문서',
    recentProjects: '최근 프로젝트',
    viewAll: '모두 보기 ({count})',
    noProjects: '프로젝트가 없습니다. 첫 번째 프로젝트를 만들어 시작하세요!',
    login: '로그인',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: '블로그',
    projectCreated: '프로젝트 생성됨',
    projectCreatedDesc: '새 프로젝트가 성공적으로 생성되었습니다',
    projectDeleted: '프로젝트 삭제됨',
    projectDeletedDesc: '프로젝트가 성공적으로 삭제되었습니다',
    deleteConfirmation: '이 프로젝트를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    migrationFailed: '마이그레이션 실패',
    migrationFailedDesc: 'localStorage에서 데이터 마이그레이션 실패',
    loadFailed: '로드 실패',
    loadFailedDesc: '프로젝트 로드 실패',
    creationFailed: '생성 실패',
    creationFailedDesc: '새 프로젝트 생성 실패',
    deletionFailed: '삭제 실패',
    deletionFailedDesc: '프로젝트 삭제 실패'
  },
  timeline: {
    autoSaveFailed: '자동 저장 실패',
    autoSaveFailedDesc: '프로젝트 자동 저장 실패',
    loadFailed: '로드 실패',
    loadFailedDesc: '프로젝트 로드 실패. 홈으로 리디렉션 중...',
    mainTrack: '메인 트랙',
    undo: '실행 취소',
    redo: '다시 실행',
    split: '분할',
    delete: '삭제'
  },
  attributes: {
    properties: '속성',
    position: '위치',
    scale: '크기',
    animation: '애니메이션',
    basic: '기본',
    mute: '음소거',
    text: '텍스트',
    fontSize: '글꼴 크기',
    content: '내용',
    fontFamily: '글꼴 모음',
    direction: '텍스트 방향',
    color: '색상',
    stroke: '획',
    background: '배경',
    video: '동영상',
    rotate: '회전',
    backgroundColor: '배경 색상',
    opacity: '불투명도',
    blend: '블렌드',
    filter: '필터',
    effect: '효과',
    transition: '전환',
    speed: '속도',
    volume: '볼륨'
  },
  router: {
    editor: '동영상 편집기',
    preview: '미리보기',
    storyboard: '스토리보드 - AI 비디오 에이전트'
  },
  placeholder: {
    text: '텍스트 내용을 입력하세요',
    input: '입력하세요'
  },
  error: {
    parseAudio: '오디오 분석 실패',
    parseImage: '이미지 분석 실패',
    parseVideo: '동영상 분석 실패',
    noProject: '먼저 프로젝트를 생성하거나 여세요',
    invalidFileType: '유효하지 않은 파일 형식'
  },
  media: {
    video: '동영상',
    image: '이미지',
    audio: '오디오',
    dropToUpload: '업로드할 파일을 여기에 드롭하세요'
  },
  common: {
    defaultText: '기본 텍스트',
    delete: '삭제'
  }
};
